import React, { Component as C } from "react"
import PropTypes from "prop-types"
import Popover from "@cirrus/legacy/app-components/popover/popover/index.jsx"
import styles from "./popover.less"

class LabelsFilterPopover extends C {
  state = {
    minLeft: 0,
  }

  static propTypes = {
    className: PropTypes.string,
    onKeyUp: PropTypes.func,
    isOpen: PropTypes.bool,
    isFixed: PropTypes.bool,
    filterLinkId: PropTypes.string,
    onUpdateMinLeft: PropTypes.func,
    onClose: PropTypes.func,
    restrictMinLeft: PropTypes.bool,
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isOpen) {
      return
    }

    if (
      this.props.isOpen !== nextProps.isOpen ||
      this.props.isFixed !== nextProps.isFixed ||
      this.props.filterLinkId !== nextProps.filterLinkId
    ) {
      this._filterLink = nextProps.isFixed
        ? document.querySelector(`[data-label-filter-link-id="${nextProps.fixedFilterLinkId}"]`)
        : document.querySelector(`[data-label-filter-link-id="${nextProps.filterLinkId}"]`)
    }

    if (
      this.props.isOpen !== nextProps.isOpen ||
      this.props.filterContainerId !== nextProps.filterContainerId
    ) {
      this._filterContainer = document.querySelector(
        `[data-label-filter-container-id="${nextProps.filterContainerId}"]`,
      )
    }
  }

  componentDidMount() {
    if (!this.props.isFixed) {
      return
    }

    let minLeft = this._getMinLeft()

    if (this.state.minLeft === minLeft) {
      return
    }

    this.setState({
      minLeft,
    })
  }

  componentDidUpdate() {
    if (!this.props.isFixed) {
      return
    }

    let minLeft = this._getMinLeft()

    if (this.state.minLeft === minLeft) {
      return
    }

    this.setState({
      minLeft,
    })
  }

  _getMinLeft() {
    if (this._filterContainer == null) {
      return 0
    }

    let filterContainerBounds = this._filterContainer.getBoundingClientRect()

    return (filterContainerBounds && filterContainerBounds.left) || 0
  }

  render() {
    let { isOpen, isFixed, onClose, restrictMinLeft } = this.props

    return isOpen ? (
      <Popover
        className={styles.popover}
        arrowClassName={styles.arrow}
        arrowOffset="-5px"
        open={isOpen}
        anchorEl={this._filterLink}
        smartPlacement={false}
        container={isFixed ? document.body : this._filterContainer}
        onRequestClose={onClose}
        minLeft={restrictMinLeft && isFixed ? this.state.minLeft : 0}>
        {this.props.children}
      </Popover>
    ) : null
  }
}

export default LabelsFilterPopover
